"use strict";
export { AvatarContext as Context, AvatarFallback as Fallback, AvatarIcon as Icon, AvatarImage as Image, AvatarPropsProvider as PropsProvider, AvatarRoot as Root, AvatarRootProvider as RootProvider } from './avatar.js';
